









































































import NotificationTypeEnum from "@/api/dataSource/api/Spirit/Entities/Enums/NotificationTypeEnum";
import CreateEmailPushViewModel from "@models/emailPush/createEmailPushViewModel";
import { Vue, Component } from "vue-property-decorator";

@Component
export default class CreateEmailPushComponent extends Vue {
  languages: string[] = [];
  isLoading = false;
  inited = false;
  get id(): number {
    const routeId = this.$route.params.id;
    return routeId ? Number(routeId) : 0;
  }
  get fieldNamesString(): string {
    return (this.vm.fieldNames || []).join(', ');
  }
  notificationTypes = [
    {id: NotificationTypeEnum.Email, text: 'Email'},
    {id: NotificationTypeEnum.Push, text: 'Пуш'},
    {id: NotificationTypeEnum.Both, text: 'Email и пуш'}
  ]
  vm: CreateEmailPushViewModel = new CreateEmailPushViewModel();
  async created() {
    this.languages = await this.$cacheProvider.getLanguagesAsync();
    this.vm.initLanguages(this.languages);
    if (this.$route.params.id) {
      await this.fetchData();
    }
    this.inited = true;
  }
  async fetchData() {
    this.isLoading = true;
    const res = await this.$api.NotificationService.getDetailAsync(this.id);
    this.vm.fromServerModel(res);
    this.isLoading = false;
  }
  toCopyBuffer(text: string) {
    if (this.$copyPaste.execute(text)) {
      this.$notification.success('Скопировано в буфер обмена');
    } else {
      this.$notification.error('Ошибка при копировании в буфер обмена');      
    }
  }
  async save() {
    const isValid = (this.$refs.validator as any).isValid();
    if (!isValid) return;
    const isTemplateValid = this.vm.isValidTemplate();
    if (!isTemplateValid) {
      this.$notification.error(`Заполните шаблон необходимыми полями! (${this.fieldNamesString})`);
      return;
    }
    this.isLoading = true;
    const request = this.vm.toServerModel();
    const res = await this.$api.NotificationService.updateAsync(
      request
    );
    if (res) {
      this.$dialog.success("Уведомление успешно обновлено");
      this.$router.back();
    }
    this.isLoading = false;
  }
}
